export const Enums = {
    FixedRate: "fixed-rate",
    FloatingRate: "standard"
}